import { createContext } from 'react';

var initalState = {
  variant: 'body'
};
var InnerContext = /*#__PURE__*/createContext(initalState);

export { InnerContext };
